import React, { FC, useEffect, useMemo } from 'react'
import SelectDropDown, { CustomDropdownPropTypes } from '../../../globalUtils/SelectDropDown/SelectDropDown'
import { useAppDispatch, useAppSelector } from '../../../globalUtils/globalExports'
import CustomDatePicker, { CustomDatePickerProps } from '../../../globalUtils/CustomDatePicker/CustomDatePicker'
// import { cloneDeep } from 'lodash'
import { Menu,MenuItem } from '@mui/material';
import './CustomFilterLayout.css';
import { Icon } from '../../../globalUtils/globalIcons'
import { fetchAcCustomerReferenceData } from '../../rmsReduxStore/acReferenceDataRedux/acReferenceDataCreator'
import { getAcFilterReducer, getAcReferenceDataReducer } from '../../rmsReduxStore/acReduxExports'
import { getAcFilterSelectedValue } from '../../rmsReduxStore/acFiltersRedux/acFiltersCreators';

export interface AcCustomFilterProp {
  filterId: string
  filterLabel: string
  filterType: 'dropdown' | 'dateFilter'
  filterDropdownProps?: CustomDropdownPropTypes | null,
  dateFilterProps?: CustomDatePickerProps | null
  width?: string
}

interface CustomFilterLayoutProps {
  screen?:string
  filters: AcCustomFilterProp[],
  excludeGlobalFilters?: boolean,
  filterAnchorEl:HTMLElement | null,
  setFilterAnchorEl:React.Dispatch<React.SetStateAction<HTMLElement | null>>,
  requiredReferenceDataCallbacks: ('customer' | 'severity' | 'chargerModel' | 'location' | 'status' | 'chargerType' | 'region' | 'softwareVersion' | 'chargingStation' | 'alarmType' | 'chargerVisibleId' | 'parameterName' | 'user' | 'editHistory' | 'orgName' | 'visibility' | 'chargingStationId'|'productType'|'alarmTypeId'|'typeOfNotification'| 'stopReasonCode' | 'ruleId' | 'alarmSeverity' |'activeCertificate' |'userRemoteCommand')[] | string[];
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleFilterDataChange?:Function;
}

export const referenceDataCallBackMapper = [
  {
    key: 'customer',
    referenceDataCallBack: fetchAcCustomerReferenceData
  }
]

const AcCustomFilterLayout: FC<CustomFilterLayoutProps> = (props) => {
  const {screen, filters, requiredReferenceDataCallbacks,handleFilterDataChange, excludeGlobalFilters,filterAnchorEl,setFilterAnchorEl } = props;
  const dispatch = useAppDispatch()
  const {acCustomerReferenceData } = useAppSelector(getAcReferenceDataReducer);
  const {globalFilters} = useAppSelector(getAcFilterReducer)

  useEffect(() => {
    if (requiredReferenceDataCallbacks && requiredReferenceDataCallbacks?.length > 0) {
      // Adding Global filters callBacks key to coming callBacks keys props...
      const referenceDataCallBacks = requiredReferenceDataCallbacks.concat(['customer'])
      referenceDataCallBacks?.forEach(type => {
        const callbackItem = referenceDataCallBackMapper?.find(item => item?.key === type);
        if (callbackItem) {
          if ((screen === 'charging_history' || screen === 'alarms') && type === 'chargerVisibleId') {
            const selectedCustomerFilter = getAcFilterSelectedValue('customer','global',true)
            const reqBody = {
              customerIds : selectedCustomerFilter?.filter((item) => item?.id === 'all')?.length > 0  ? ['all'] : selectedCustomerFilter?.map((customer) => customer?.id)
            }
            dispatch(callbackItem?.referenceDataCallBack(reqBody))
          } else {
            dispatch(callbackItem?.referenceDataCallBack())
          }
        }
      })
    } else {
      dispatch(fetchAcCustomerReferenceData())
    }
  }, [])


  const globalFiltersProps: AcCustomFilterProp[] = useMemo(() => {
    return [
      {
        filterLabel: screen === 'newDashboard' ? 'Customer' : 'Customers',
        filterType: 'dropdown',
        filterId: 'Customer',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('customer','global',true),
          selectOptions: acCustomerReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange?.(val, 'customer',true)
          },
          selectDropDownId: 'charger-customer-filter-dropdown',
          isMultiSelect: true,
          renderToBody: true
        }
      },
    ]
    
  }, [ acCustomerReferenceData,globalFilters])



  const allFilters = excludeGlobalFilters? [...filters] : [...globalFiltersProps,...filters]

  return (
    <Menu
        id='custom-filters-dropdown'
        anchorEl={filterAnchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className='custom__filters__dropdown__container'
        sx={{ top: '30px' }}
        open={Boolean(filterAnchorEl)}
        onClose={()=>{setFilterAnchorEl(null)}}
        slotProps={{
            paper: {
                sx: {
                minWidth: '200px',
            },
        },
        }}
    >
    <div className='custom-filters-dropdown-header'>
        <div className='custom-filters-dropdown-header-heading'>Add Filters</div>
        <div className='custom-filters-dropdown-header-close-btn'>
            <Icon iconClassName='react__select__dropdown__cross__icon' onIconClick={()=>{setFilterAnchorEl(null)}}/>
        </div>
    </div>
    <div className='custom-filters-dropdown-body'>
        {
        allFilters && allFilters?.length > 0 && allFilters?.map((filter, index) => {
      return (
        <MenuItem key={index} 
            disableRipple
            sx={{
            '&:hover': {backgroundColor: 'transparent'},
            '&.Mui-selected': { backgroundColor: 'transparent' }, // selected
            '&.Mui-focusVisible': { backgroundColor: 'transparent' }, 
            cursor:'default'
        }}
        onKeyDown={(e)=>{e.stopPropagation()}} //stops event propagation to parent.
        >
            <div className="custom__filter__wrap-content-row" style={{width:'200px'}}>
          <div className="custom__filter__wrap-content-row-label">{filter?.filterLabel}</div>
          <div className="custom__filter__wrap-content_filter">
            {filter.filterType === 'dropdown' && filter?.filterDropdownProps &&
              <SelectDropDown
                selectValue={filter?.filterDropdownProps?.selectValue}
                selectOptions={filter?.filterDropdownProps?.selectOptions ?? []}
                handleSelectOptionChange={filter?.filterDropdownProps?.handleSelectOptionChange}
                selectDropDownId={filter?.filterDropdownProps?.selectDropDownId}
                isMultiSelect={filter?.filterDropdownProps?.isMultiSelect}
                renderToBody={filter?.filterDropdownProps?.renderToBody}
                menuPlacement={filter?.filterDropdownProps?.menuPlacement}
                // renderToBody={true}
              />
            }
            {filter.filterType === 'dateFilter' && filter?.dateFilterProps &&
              <CustomDatePicker startDate={filter?.dateFilterProps?.startDate ? new Date(filter?.dateFilterProps?.startDate) : null} endDate={filter?.dateFilterProps?.endDate ? new Date(filter?.dateFilterProps?.endDate) : null} selectsRange={filter?.dateFilterProps?.selectsRange} onChange={filter?.dateFilterProps?.onChange} includeDateIntervals={filter?.dateFilterProps.includeDateIntervals} />}
          </div>
        </div>

        </MenuItem>
      )
    }
    )
    }
    </div>
    </Menu>
    )
}

export default AcCustomFilterLayout